export const switchPlaylitsIsPublicDataSet = { cy: 'toggle-playlist-public-button' };
export const playlistSettingsDataSet = { cy: 'playlist-settings' };
